@if (slide) {
  @if (slide.picture_tag_info) {
    <div class="col-12 position-relative hasimage {{ slide.background }}">
      @if (slide.picture_tag_info) {
        <wagtail-page-element-image
          [image]="slide.picture_tag_info"
        ></wagtail-page-element-image>
      }
      <div class="carousel-caption d-none d-md-block">
        <wagtail-page-element-full-bleed-slider-caption [slide]="slide"></wagtail-page-element-full-bleed-slider-caption>
      </div>
    </div>
  } @else {
    <div class="col-12 noimage {{ slide!.background  }}">
      <wagtail-page-element-full-bleed-slider-caption [slide]="slide"></wagtail-page-element-full-bleed-slider-caption>
    </div>
  }
}

